const testIds = {
  // Pages
  FF_FORM_BUILDER_PAGE: 'ff-form-builder-page',
  FF_FORM_MANAGEMENT_PAGE: 'ff-form-management-page',
  FF_LIVE_FORM_PAGE: 'ff-live-form-page',
  // Global / Shared Components
  FF_TAGS_INPUT_REMOVE_TAG_CHIP: 'ff-tags-input-remove-tag-chip',
  // Form Management – Filters & Actions
  FF_FORM_MANAGEMENT_LIST_ROW: 'ff-form-management-list-row',
  FF_FORM_MANAGEMENT_STATUS_FILTER: 'ff-form-management-status-filter',
  FF_FORM_MANAGEMENT_CREATOR_FILTER: 'ff-form-management-creator-filter',
  FF_FORM_MANAGEMENT_UPDATER_FILTER: 'ff-form-management-updater-filter',
  FF_FORM_MANAGEMENT_AUTH_FILTER: 'ff-form-management-auth-filter',
  FF_FORM_MANAGEMENT_CREATE_FORM_BUTTON:
    'ff-form-management-create-form-button',
  FF_FORM_MANAGEMENT_DYNAMIC_ATTRIBUTE_BUTTON:
    'ff-form-management-dynamic-attribute-button',
  FF_FORM_MANAGEMENT_CREDENTIALS_BUTTON:
    'ff-form-management-credentials-button',
  FF_FORM_MANAGEMENT_SEARCH_INPUT: 'ff-form-management-search-input',
  FF_FORM_MANAGEMENT_FILTER_BUTTON: 'ff-form-management-filter-button',
  FF_FORM_MANAGEMENT_IMPORT_BUTTON: 'ff-form-management-import-button',
  FF_FORM_MANAGEMENT_CLEAR_FILTERS_BUTTON:
    'ff-form-management-clear-filters-button',
  FF_FORM_ROW_MORE_ACTIONS_BUTTON: 'ff-form-row-more-actions-button',
  FF_FORM_ROW_ACTIONS_MENU: 'ff-form-row-actions-menu',
  // Mapping Table
  FF_MAPPING_TABLE_SORTABLE: 'ff-mapping-table-sortable',
  FF_MAPPING_TABLE_ATTRIBUTE_MENU: 'ff-mapping-table-attribute-menu',
  FF_MAPPING_TABLE_ACTION_MENU: 'ff-mapping-table-action-menu',
  FF_MAPPING_TABLE_ACTION_BUTTON: 'ff-mapping-table-action-button',
  // Tools / Builder UI Controls
  FF_TOOLS_PANEL_SETTINGS_BUTTON: 'ff-tools-panel-settings-button',
  FF_TOOLS_PANEL_SETTINGS_MENU: 'ff-tools-panel-settings-menu',
  FF_TOOLS_PANEL_CLOSE_BUTTON: 'ff-tools-panel-close-button',
  FF_PROPERTIES_PANEL_BACK_BUTTON: 'ff-properties-panel-back-button',
  FF_PROPERTIES_PANEL_SETTINGS_BUTTON: 'ff-properties-panel-settings-button',
  FF_PROPERTIES_PANEL_SETTINGS_MENU: 'ff-properties-panel-settings-menu',
  FF_PROPERTIES_PANEL_PROPERTIES_TAB: 'ff-properties-panel-properties-tab',
  FF_PROPERTIES_PANEL_LOGIC_TAB: 'ff-properties-panel-logic-tab',
  FF_FIELD_HOVER_RESIZE_BUTTON: 'ff-field-hover-resize-button',
  FF_FIELD_HOVER_DELETE_BUTTON: 'ff-field-hover-delete-button',
  FF_TOOL_ACCORDION_TOGGLE_BUTTON: 'ff-tool-accordion-toggle-button',
  // Prompts / Modals – Go Back / Delete / Submit
  FF_GO_BACK_PROMPT_MODAL: 'ff-go-back-prompt-modal',
  FF_GO_BACK_PROMPT_EXIT_BUTTON: 'ff-go-back-prompt-exit-button',
  FF_GO_BACK_PROMPT_SAVE_EXIT_BUTTON: 'ff-go-back-prompt-save-exit-button',
  FF_PREVIEW_PROMPT_MODAL: 'ff-preview-prompt-modal',
  FF_PREVIEW_PROMPT_CANCEL_BUTTON: 'ff-preview-prompt-cancel-button',
  FF_PREVIEW_PROMPT_SAVE_AND_PREVIEW_BUTTON:
    'ff-preview-prompt-save-and-preview-button',
  FF_DELETE_FIELD_PROMPT_MODAL: 'ff-delete-field-prompt-modal',
  FF_DELETE_FIELD_PROMPT_CANCEL_BUTTON: 'ff-delete-field-prompt-cancel-button',
  FF_DELETE_FIELD_PROMPT_DELETE_BUTTON: 'ff-delete-field-prompt-delete-button',
  FF_DELETE_SECTION_PROMPT_MODAL: 'ff-delete-section-prompt-modal',
  FF_DELETE_SECTION_PROMPT_YES_BUTTON: 'ff-delete-section-prompt-yes-button',
  FF_DELETE_SECTION_PROMPT_NO_BUTTON: 'ff-delete-section-prompt-no-button',
  FF_SUBMIT_PROMPT_MODAL: 'ff-submit-prompt-modal',
  FF_SUBMIT_PROMPT_FORMS_BUTTON: 'ff-submit-prompt-forms-button',
  FF_SUBMIT_PROMPT_CONTINUE_BUTTON: 'ff-submit-prompt-continue-button',
  FF_SUBMIT_PROMPT_CLOSE_BUTTON: 'ff-submit-prompt-close-button',
  // Branding / Assets
  FF_BRANDING_LOGO_UPLOAD: 'ff-branding-logo-upload',
  FF_BRANDING_SUBMIT_BTN_LABEL: 'ff-branding-submit-btn-label',
  FF_BRANDING_SUCCESS_MSG: 'ff-branding-success-msg',
  FF_DETAIL_AUTH_TOGGLE: 'ff-detail-auth-toggle',
  FF_DETAIL_AUTH_TOGGLE_VIEW: 'ff-detail-auth-toggle-view',
  // HTTP Provider
  FF_HTTP_PROVIDER_CONFIGURE_BUTTON: 'ff-http-provider-configure-button',
  FF_SAV_OQ_PROVIDER_CONFIGURE_BUTTON: 'ff-sav-oq-provider-configure-button',
  FF_SAV_OQ_PROVIDER_MODAL: 'ff-sav-oq-provider-modal',
  FF_SAV_OQ_OBJECT_SELECT: 'ff-sav-oq-object-select',
  FF_SAV_OQ_LABEL_FIELD: 'ff-sav-oq-label-field',
  FF_SAV_OQ_VALUE_FIELD: 'ff-sav-oq-value-field',
  FF_SAV_OQ_PAGE_SIZE: 'ff-sav-oq-page-size',
  FF_SAV_OQ_TEST_PREVIEW: 'ff-sav-oq-test-preview',
  FF_SAV_OQ_PREVIEW_BUTTON: 'ff-sav-oq-preview-button',
  FF_SAV_OQ_DISTINCT: 'ff-sav-oq-distinct',
  FF_SAV_OQ_PARAMS_ADD: 'ff-sav-oq-params-add',
  FF_SAV_OQ_PARAM_REMOVE: 'ff-sav-oq-param-remove',
  FF_SAV_OQ_SAVE: 'ff-sav-oq-save',
  FF_SAV_OQ_CANCEL: 'ff-sav-oq-cancel',
  FF_SAV_OQ_MODAL_HEADER_CLOSE: 'ff-sav-oq-modal-header-close',
  // Delete / Resize Zones & Body Controls
  FF_BUILD_BODY_CONTROLS_GROUP: 'ff-build-body-controls-group',
  FF_BUILD_BODY_CONTROLS_BUILD_TAB: 'ff-build-body-controls-build-tab',
  FF_BUILD_BODY_CONTROLS_MAPPING_TAB: 'ff-build-body-controls-mapping-tab',
  FF_BUILD_BODY_CONTROLS_PREVIEW: 'ff-build-body-controls-preview-tab',
  // Export Modal
  FF_FORM_EXPORT_MODAL: 'ff-form-export-modal',
  FF_FORM_EXPORT_MODAL_EXPORT_BUTTON: 'ff-form-export-modal-export-button',
  FF_FORM_EXPORT_MODAL_CANCEL_BUTTON: 'ff-form-export-modal-cancel-button',
  // Canvas – Common Inputs
  FF_CANVAS_CHECKBOX: 'ff-canvas-checkbox',
  FF_CANVAS_RADIO_BUTTON: 'ff-canvas-radio-button',
  FF_CANVAS_DATE_PICKER: 'ff-canvas-date-picker',
  // Field Visibility / Requirements
  FF_REQUIRED_TOGGLE_SWITCH: 'ff-required-toggle-switch',
  FF_REQUIRED_ERROR_MESSAGE_INPUT: 'ff-required-error-message-input',
  FF_HIDDEN_TOGGLE_SWITCH: 'ff-hidden-toggle-switch',
  FF_HIDDEN_VALUE_INPUT: 'ff-hidden-value-input',
  FF_PASSWORD_CONFIRMATION_TOGGLE_SWITCH:
    'ff-password-confirmation-toggle-switch',
  FF_AUTO_GENERATION_TOGGLE_SWITCH: 'ff-auto-generation-toggle-switch',
  // Alert Banners – Form Builder
  FF_FORM_BUILDER_DROP_DENIED_ALERT: 'ff-form-builder-drop-denied-alert',
  FF_FORM_BUILDER_FIELD_LIMIT_ALERT: 'ff-form-builder-field-limit-alert',
  FF_FORM_BUILDER_RICH_TEXT_LIMIT_ALERT:
    'ff-form-builder-rich-text-limit-alert',
  FF_FORM_BUILDER_PASSWORD_LIMIT_ALERT: 'ff-form-builder-password-limit-alert',
  FF_FORM_BUILDER_VALIDATION_ERROR_ALERT:
    'ff-form-builder-validation-error-alert',
  FF_FORM_BUILDER_LOGO_SUCCESS_ALERT: 'ff-form-builder-logo-success-alert',
  FF_FORM_BUILDER_LOGO_TOO_LARGE_ALERT: 'ff-form-builder-logo-too-large-alert',
  FF_FORM_BUILDER_LOGO_UNSUPPORTED_TYPE_ALERT:
    'ff-form-builder-logo-unsupported-type-alert',
  FF_FORM_BUILDER_LOGO_INFECTED_ALERT: 'ff-form-builder-logo-infected-alert',
  FF_FORM_BUILDER_LOGO_FAILED_ALERT: 'ff-form-builder-logo-failed-alert',
  FF_FORM_BUILDER_LOGO_UPLOADING_ALERT: 'ff-form-builder-logo-uploading-alert',
  FF_FORM_BUILDER_SAVE_ERROR_ALERT: 'ff-form-builder-save-error-alert',
  FF_FORM_BUILDER_PUBLISH_ERROR_ALERT: 'ff-form-builder-publish-error-alert',
  // Alert Banners – Live Form
  FF_LIVE_FORM_REQUIREMENTS_NOT_MET_ALERT:
    'ff-live-form-requirements-not-met-alert',
  FF_LIVE_FORM_SUBMIT_SUCCESS_ALERT: 'ff-live-form-submit-success-alert',
  FF_LIVE_FORM_SUBMIT_NO_DATA_ALERT: 'ff-live-form-submit-no-data-alert',
  FF_LIVE_FORM_SUBMIT_NO_CHANGES_ALERT: 'ff-live-form-submit-no-changes-alert',
  // Import Modal
  FF_FORM_IMPORT_MODAL: 'ff-form-import-modal',
  FF_FORM_IMPORT_MODAL_CLOSE_BUTTON: 'ff-form-import-modal-close-button',
  FF_FORM_IMPORT_MODAL_UPLOAD: 'ff-form-import-modal-upload',
  FF_FORM_IMPORT_MODAL_NAME_INPUT: 'ff-form-import-modal-name-input',
  FF_FORM_IMPORT_MODAL_CANCEL_BUTTON: 'ff-form-import-modal-cancel-button',
  FF_FORM_IMPORT_MODAL_IMPORT_BUTTON: 'ff-form-import-modal-import-button',
  // Detail Inputs
  FF_FIELD_LABEL_INPUT: 'ff-field-label-input',
  // Field Properties Panel – Inputs
  FF_PROPERTIES_ELEMENT_SELECTED_INPUT: 'ff-properties-element-selected-input',
  FF_PROPERTIES_HELPER_TEXT_INPUT: 'ff-properties-helper-text-input',
  FF_PROPERTIES_DESCRIPTION_INPUT: 'ff-properties-description-input',
  FF_PROPERTIES_PLACEHOLDER_INPUT: 'ff-properties-placeholder-input',
  FF_PROPERTIES_ELEMENT_ID_INPUT: 'ff-properties-element-id-input',
  FF_PROPERTIES_DEFAULT_VALUE_INPUT: 'ff-properties-default-value-input',
  FF_PROPERTIES_DEFAULT_VALUE_EXPRESSION_SWITCH:
    'ff-properties-default-value-expression-switch',
  FF_PROPERTIES_EXPRESSION_VALIDATION_TOGGLE:
    'ff-properties-expression-validation-toggle',
  FF_PROPERTIES_EXPRESSION_VALIDATION_VALUE_INPUT:
    'ff-properties-expression-validation-value-input',
  FF_PROPERTIES_EXPRESSION_VALIDATION_ERROR_INPUT:
    'ff-properties-expression-validation-error-input',
  FF_PROPERTIES_INLINE_MESSAGE_INPUT: 'ff-properties-inline-message-input',

  FF_PROPERTIES_TOOLTIP_INPUT: 'ff-properties-tooltip-input',
  FF_PROPERTIES_TOOLTIP_TOGGLE: 'ff-properties-tooltip-toggle',
  FF_PROPERTIES_READ_ONLY_TOGGLE: 'ff-properties-read-only-toggle',
  FF_PROPERTIES_READ_ONLY_VALUE_INPUT: 'ff-properties-read-only-value-input',
  FF_PROPERTIES_ENFORCE_READING_TOGGLE: 'ff-properties-enforce-reading-toggle',
  // SQL Provider Inputs
  FF_PROPERTIES_SQL_MAPPING_VALUE_INPUT:
    'ff-properties-sql-mapping-value-input',
  FF_PROPERTIES_SQL_MAPPING_LABEL_INPUT:
    'ff-properties-sql-mapping-label-input',
  FF_PROPERTIES_SQL_SELECT_INPUT: 'ff-properties-sql-select-input',
  FF_PROPERTIES_SQL_FROM_INPUT: 'ff-properties-sql-from-input',
  FF_PROPERTIES_SQL_WHERE_INPUT: 'ff-properties-sql-where-input',
  FF_PROPERTIES_SQL_POSTWHERE_INPUT: 'ff-properties-sql-postwhere-input',
  // Fixed Group Options
  FF_PROPERTIES_FIXED_GROUP_OPTION_LABEL:
    'ff-properties-fixed-group-option-label',
  FF_PROPERTIES_FIXED_GROUP_OPTION_VALUE:
    'ff-properties-fixed-group-option-value',
  FF_PROPERTIES_FIXED_GROUP_OPTION_DELETE:
    'ff-properties-fixed-group-option-delete',
  FF_PROPERTIES_FIXED_GROUP_ADD_BUTTON: 'ff-properties-fixed-group-add-button',
  FF_PROPERTIES_CHARACTER_LIMIT_MIN: 'ff-properties-character-limit-min',
  FF_PROPERTIES_CHARACTER_LIMIT_MAX: 'ff-properties-character-limit-max',
  FF_PROPERTIES_CHARACTER_LIMIT_ERROR_MESSAGE:
    'ff-properties-character-limit-error-message',
  FF_PROPERTIES_NUMERICAL_LIMIT_MIN: 'ff-properties-numerical-limit-min',
  FF_PROPERTIES_NUMERICAL_LIMIT_MAX: 'ff-properties-numerical-limit-max',
  FF_PROPERTIES_DATE_LIMIT_MIN: 'ff-properties-date-limit-min',
  FF_PROPERTIES_DATE_LIMIT_MAX: 'ff-properties-date-limit-max',
  FF_LOGIC_REGEX_VALIDATION_TOGGLE: 'ff-logic-regex-validation-toggle',
  FF_LOGIC_REGEX_PATTERN_TYPE_SELECT: 'ff-logic-regex-pattern-type-select',
  FF_LOGIC_REGEX_CUSTOM_PATTERN_INPUT: 'ff-logic-regex-custom-pattern-input',
  FF_LOGIC_REGEX_ERROR_MESSAGE_INPUT: 'ff-logic-regex-error-message-input',
  FF_LOGIC_NUMBER_REGEX_VALIDATION_TOGGLE:
    'ff-logic-number-regex-validation-toggle',
  FF_LOGIC_NUMBER_REGEX_PATTERN_TYPE_SELECT:
    'ff-logic-number-regex-pattern-type-select',
  FF_LOGIC_NUMBER_REGEX_CUSTOM_PATTERN_INPUT:
    'ff-logic-number-regex-custom-pattern-input',
  FF_LOGIC_NUMBER_REGEX_ERROR_MESSAGE_INPUT:
    'ff-logic-number-regex-error-message-input',
  FF_HTTP_QUERY_PARAMS_ADD_BUTTON: 'ff-http-query-params-add-button',
  FF_HTTP_QUERY_PARAMS_DELETE_BUTTON: 'ff-http-query-params-delete-button',
  FF_HTTP_HEADERS_ADD_BUTTON: 'ff-http-headers-add-button',
  FF_HTTP_HEADERS_DELETE_BUTTON: 'ff-http-headers-delete-button',
  FF_HTTP_REQUEST_BODY_ADD_BUTTON: 'ff-http-request-body-add-button',
  FF_HTTP_REQUEST_BODY_DELETE_BUTTON: 'ff-http-request-body-delete-button',
  FF_HTTP_MODAL_HEADER_CLOSE_BUTTON: 'ff-http-modal-header-close-button',
  FF_HTTP_PAGINATION_ADD_BUTTON: 'ff-http-pagination-add-button',
  FF_HTTP_PAGINATION_DELETE_BUTTON: 'ff-http-pagination-delete-button',
  FF_HTTP_MODAL_FOOTER_TEST_CONNECTION: 'ff-http-modal-footer-test-connection',
  FF_DETAIL_FORM_NAME_INPUT: 'ff-detail-form-name-input',
  FF_DETAIL_FORM_ID_INPUT: 'ff-detail-form-id-input',
  FF_DETAIL_FORM_DESCRIPTION_INPUT: 'ff-detail-form-description-input',
  FF_DETAIL_FORM_CATEGORY_SELECT: 'ff-detail-form-category-select',
  FF_FORM_CATEGORY_SELECT: 'ff-form-category-select',
  FF_USER_ACTION_SELECT: 'ff-user-action-select',
  FF_ORCHESTRATION_INVOKE_METHOD_SELECT:
    'ff-orchestration-invoke-method-select',
  FF_DETAIL_FORM_URL_INPUT: 'ff-detail-form-url-input',
  FF_DETAIL_FORM_WORKFLOW_SELECT: 'ff-detail-form-workflow-select',
  FF_DETAIL_FORM_USER_ACTION_SELECT: 'ff-detail-form-user-action-select',
  // Form Management – Alerts
  FF_FORM_MANAGEMENT_ALERT_EXPORT_SUCCESS:
    'ff-form-management-alert-export-success',
  FF_FORM_MANAGEMENT_ALERT_EXPORT_ERROR:
    'ff-form-management-alert-export-error',
  FF_FORM_MANAGEMENT_ALERT_IMPORT_SUCCESS:
    'ff-form-management-alert-import-success',
  FF_FORM_MANAGEMENT_ALERT_IMPORT_ERROR:
    'ff-form-management-alert-import-error',
  FF_FORM_MANAGEMENT_ALERT_DUPLICATE_SUCCESS:
    'ff-form-management-alert-duplicate-success',
  FF_FORM_MANAGEMENT_ALERT_DUPLICATE_ERROR:
    'ff-form-management-alert-duplicate-error',
  FF_FORM_MANAGEMENT_ALERT_ARCHIVE_SUCCESS:
    'ff-form-management-alert-archive-success',
  FF_FORM_MANAGEMENT_ALERT_ARCHIVE_ERROR:
    'ff-form-management-alert-archive-error',
  FF_FORM_MANAGEMENT_ALERT_DISABLE_SUCCESS:
    'ff-form-management-alert-disable-success',
  FF_FORM_MANAGEMENT_ALERT_DISABLE_ERROR:
    'ff-form-management-alert-disable-error',
  FF_FORM_MANAGEMENT_ALERT_SHARE_SUCCESS:
    'ff-form-management-alert-share-success',
  FF_FORM_MANAGEMENT_ALERT_SHARE_ERROR: 'ff-form-management-alert-share-error',
  FF_FORM_MANAGEMENT_ALERT_LIST_LOAD_ERROR:
    'ff-form-management-alert-list-load-error',
  // Form Builder – Page Buttons / Inputs
  FF_FORM_BUILDER_GO_BACK_BUTTON: 'ff-form-builder-go-back-button',
  FF_FORM_BUILDER_SAVE_BUTTON: 'ff-form-builder-save-button',
  FF_FORM_BUILDER_PUBLISH_BUTTON: 'ff-form-builder-publish-button',
  FF_FORM_BUILDER_OPEN_DRAWER_BUTTON: 'ff-form-builder-open-drawer-button',
  FF_FORM_BUILDER_FORM_NAME_INPUT: 'ff-form-builder-form-name-input',
  // Field Property Controls (Layout, Data, etc.)
  FF_PROPERTIES_PAST_DATE_ALLOWED_TOGGLE:
    'ff-properties-past-date-allowed-toggle',
  FF_PROPERTIES_LAYOUT_SELECT: 'ff-properties-layout-select',
  FF_PROPERTIES_ALIGNMENT_SELECT: 'ff-properties-alignment-select',
  FF_PROPERTIES_FIXED_GROUP_OPTIONS_INPUT:
    'ff-properties-fixed-group-options-input',
  FF_PROPERTIES_CHARACTER_LIMIT_INPUT: 'ff-properties-character-limit-input',
  FF_PROPERTIES_COLUMN_SPAN_SELECT: 'ff-properties-column-span-select',
  FF_PROPERTIES_FUTURE_DATE_ALLOWED_TOGGLE:
    'ff-properties-future-date-allowed-toggle',
  FF_PROPERTIES_ROWS_INPUT: 'ff-properties-rows-input',
  FF_PROPERTIES_DATE_LIMIT_INPUT: 'ff-properties-date-limit-input',
  FF_PROPERTIES_DATE_FORMAT_SELECT: 'ff-properties-date-format-select',
  FF_PROPERTIES_DATA_PROVIDERS_SELECT: 'ff-properties-data-providers-select',
  FF_PROPERTIES_TNC_TYPE_SELECT: 'ff-properties-tnc-type-select',
  FF_PROPERTIES_TNC_LINK_SELECT: 'ff-properties-tnc-link-select',
  FF_PROPERTIES_SPACER_HEIGHT_INPUT: 'ff-properties-spacer-height-input',
  FF_LOGIC_REGEX_VALIDATION_INPUT: 'ff-logic-regex-validation-input',
  FF_PASSWORD_REGEX_CODE_INPUT: 'ff-password-regex-code-input',
  FF_PASSWORD_REGEX_ERROR_MESSAGE_INPUT:
    'ff-password-regex-error-message-input',
  // HTTP Provider Modal – Inputs & Buttons
  FF_HTTP_PROVIDER_MODAL: 'ff-http-provider-modal',
  FF_HTTP_BASIC_CONFIG_CONNECTION_NAME: 'ff-http-basic-config-connection-name',
  FF_HTTP_BASIC_CONFIG_METHOD_SELECT: 'ff-http-basic-config-method-select',
  FF_HTTP_BASIC_CONFIG_RESOURCE_URL: 'ff-http-basic-config-resource-url',
  FF_HTTP_RESPONSE_MAPPING_LABEL_PATH: 'ff-http-response-mapping-label-path',
  FF_HTTP_RESPONSE_MAPPING_VALUE_PATH: 'ff-http-response-mapping-value-path',
  FF_HTTP_QUERY_PARAMS_KEY_INPUT: 'ff-http-query-params-key-input',
  FF_HTTP_QUERY_PARAMS_VALUE_INPUT: 'ff-http-query-params-value-input',
  FF_HTTP_HEADERS_KEY_INPUT: 'ff-http-headers-key-input',
  FF_HTTP_HEADERS_VALUE_INPUT: 'ff-http-headers-value-input',
  FF_HTTP_REQUEST_BODY_TEXTAREA: 'ff-http-request-body-textarea',
  FF_HTTP_MODAL_HEADER_TITLE: 'ff-http-modal-header-title',
  FF_HTTP_PAGINATION_PAGE_KEY: 'ff-http-pagination-page-key',
  FF_HTTP_PAGINATION_PAGE_SIZE_KEY: 'ff-http-pagination-page-size-key',
  FF_HTTP_PAGINATION_PAGE_SIZE: 'ff-http-pagination-page-size',
  FF_HTTP_PAGINATION_TOTAL_PAGES_KEY: 'ff-http-pagination-total-pages-key',
  FF_HTTP_PAGINATION_TOTAL_ITEMS_KEY: 'ff-http-pagination-total-items-key',
  FF_HTTP_MODAL_FOOTER_SAVE_BUTTON: 'ff-http-modal-footer-save-button',
  FF_HTTP_MODAL_FOOTER_CANCEL_BUTTON: 'ff-http-modal-footer-cancel-button',
  // Form Builder – Detail Component
  FF_FORM_BUILDER_DETAIL_COMPONENT: 'ff-form-builder-detail-component',
  // Canvas Field Components
  FF_CANVAS_TEXT_INPUT: 'ff-canvas-text-input',
  FF_CANVAS_TEXT_AREA: 'ff-canvas-text-area',
  FF_CANVAS_NUMBER_INPUT: 'ff-canvas-number-input',
  FF_CANVAS_PASSWORD_INPUT: 'ff-canvas-password-input',
  FF_CANVAS_PASSWORD_INPUT_CONFIRM: 'ff-canvas-password-input-confirm',
  FF_CANVAS_BOOLEAN: 'ff-canvas-boolean',
  FF_CANVAS_SINGLE_SELECT: 'ff-canvas-single-select',
  FF_CANVAS_MULTI_SELECT: 'ff-canvas-multi-select',
  FF_CANVAS_SENSITIVE: 'ff-canvas-sensitive',
  FF_CANVAS_CONDITIONAL_LOGIC: 'ff-canvas-conditional-logic',
  FF_CANVAS_CONDITIONAL_DROPDOWN: 'ff-canvas-conditional-dropdown',
  FF_CANVAS_CONDITIONAL_SWITCH: 'ff-canvas-conditional-switch',

  // Page Alert Containers
  FF_FORM_MANAGEMENT_ALERTS: 'ff-form-management-alerts',
  // Page Components
  FF_FORM_BUILDER_PAGE_COMPONENT: 'ff-form-builder-page-component',
  // LiveForm Components
  FF_LIVE_FORM_CLOSE_BUTTON: 'ff-live-form-close-button',
  FF_LIVE_FORM_VIEW_REQUEST_BUTTON: 'ff-live-form-view-request-button',
  FF_LIVE_FORM_EXIT_BUTTON: 'ff-live-form-exit-button',
  FF_LIVE_FORM_REFRESH_BUTTON: 'ff-live-form-refresh-button',
  FF_LIVE_FORM_CLEAR_BUTTON: 'ff-live-form-clear-button',
  FF_LIVE_FORM_METADATA_FORM: 'ff-live-form-metadata-form',
  FF_LIVE_FORM_SUBMIT_BUTTON: 'ff-live-form-submit-button',
  // LiveForm – Inactivity Timeout
  FF_LIVE_FORM_INACTIVITY_WARNING_MODAL:
    'ff-live-form-inactivity-warning-modal',
  FF_LIVE_FORM_INACTIVITY_WARNING_DISMISS:
    'ff-live-form-inactivity-warning-dismiss',
  // Dynamic Attribute Live Form Components
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_PAGE: 'ff-dynamic-attribute-live-form-page',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_CLOSE_BUTTON:
    'ff-dynamic-attribute-live-form-close-button',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_VIEW_REQUEST_BUTTON:
    'ff-dynamic-attribute-live-form-view-request-button',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_EXIT_BUTTON:
    'ff-dynamic-attribute-live-form-exit-button',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_REFRESH_BUTTON:
    'ff-dynamic-attribute-live-form-refresh-button',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_CLEAR_BUTTON:
    'ff-dynamic-attribute-live-form-clear-button',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_METADATA_FORM:
    'ff-dynamic-attribute-live-form-metadata-form',
  FF_DYNAMIC_ATTRIBUTE_LIVE_FORM_SUBMIT_BUTTON:
    'ff-dynamic-attribute-live-form-submit-button',
  // FormPreview Components
  FF_PREVIEW_OVERLAY_MOBILE_BUTTON: 'ff-preview-overlay-mobile-button',
  FF_PREVIEW_OVERLAY_TABLET_BUTTON: 'ff-preview-overlay-tablet-button',
  FF_PREVIEW_OVERLAY_DESKTOP_BUTTON: 'ff-preview-overlay-desktop-button',
  FF_PREVIEW_OVERLAY_CLOSE_BUTTON: 'ff-preview-overlay-close-button',
  FF_PREVIEW_OVERLAY_VIEW_REQUEST_BUTTON:
    'ff-preview-overlay-view-request-button',
  FF_PREVIEW_OVERLAY_VERTICAL_BUTTON: 'ff-preview-overlay-vertical-button',
  FF_PREVIEW_OVERLAY_HORIZONTAL_BUTTON: 'ff-preview-overlay-horizontal-button',
  FF_PREVIEW_OVERLAY_CLEAR_BUTTON: 'ff-preview-overlay-clear-button',
  FF_PREVIEW_OVERLAY_METADATA_FORM: 'ff-preview-overlay-metadata-form',
  FF_PREVIEW_OVERLAY_SUBMIT_BUTTON: 'ff-preview-overlay-submit-button',
  FF_PREVIEW_OVERLAY_FORM_UNAVAILABLE: 'ff-preview-overlay-form-unavailable',
  // PreviewFields Components
  FF_PREVIEW_DATE_PICKER_FIELD: 'ff-preview-date-picker-field',
  FF_PREVIEW_RADIO_FIELD: 'ff-preview-radio-field',
  FF_PREVIEW_TEXT_INPUT_FIELD: 'ff-preview-text-input-field',
  FF_PREVIEW_TEXT_AREA_FIELD: 'ff-preview-text-area-field',
  FF_PREVIEW_NUMBER_INPUT_FIELD: 'ff-preview-number-input-field',
  FF_PREVIEW_PASSWORD_FIELD: 'ff-preview-password-field',
  FF_PREVIEW_PASSWORD_FIELD_CONFIRM: 'ff-preview-password-field-confirm',
  FF_PREVIEW_PASSWORD_GENERATE: 'ff-preview-password-generate',
  FF_PREVIEW_BOOLEAN_SWITCH_FIELD: 'ff-preview-boolean-switch-field',
  FF_PREVIEW_SINGLE_SELECT_FIELD: 'ff-preview-single-select-field',
  FF_PREVIEW_CHECKBOX_FIELD: 'ff-preview-checkbox-field',
  FF_PREVIEW_MULTI_SELECT_FIELD: 'ff-preview-multi-select-field',
  FF_PREVIEW_SENSITIVE: 'ff-preview-sensitive',
  // Share Modal
  FF_FORM_SHARE_MODAL: 'ff-form-share-modal',
  FF_FORM_SHARE_MODAL_CLOSE_BUTTON: 'ff-form-share-modal-close-button',
  FF_FORM_SHARE_MODAL_SEARCH_INPUT: 'ff-form-share-modal-search-input',
  FF_FORM_SHARE_MODAL_SELECTED_SEARCH_INPUT:
    'ff-form-share-modal-selected-search-input',
  FF_FORM_SHARE_MODAL_AVAILABLE_LIST: 'ff-form-share-modal-available-list',
  FF_FORM_SHARE_MODAL_SELECTED_LIST: 'ff-form-share-modal-selected-list',
  FF_FORM_SHARE_MODAL_ADD_ITEM_BUTTON: 'ff-form-share-modal-add-item-button',
  FF_FORM_SHARE_MODAL_REMOVE_ITEM_BUTTON:
    'ff-form-share-modal-remove-item-button',
  FF_FORM_SHARE_MODAL_REMOVE_ALL_BUTTON:
    'ff-form-share-modal-remove-all-button',
  FF_FORM_SHARE_MODAL_MESSAGE_INPUT: 'ff-form-share-modal-message-input',
  FF_FORM_SHARE_MODAL_CANCEL_BUTTON: 'ff-form-share-modal-cancel-button',
  FF_FORM_SHARE_MODAL_SHARE_BUTTON: 'ff-form-share-modal-share-button',
  FF_RICH_TEXT_EDIT_CONTENT_BUTTON: 'ff-rich-text-edit-content-button',
  FF_RICH_TEXT_EDIT_MODAL: 'ff-rich-text-edit-modal',
  FF_RICH_TEXT_EDIT_MODAL_SAVE_BUTTON: 'ff-rich-text-edit-modal-save-button',

  // DYNAMIC_ATTRIBUTE_MODAL
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL: 'ff-form-dynamic-attribute-modal',
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL_CLOSE_BUTTON:
    'ff-form-dynamic-attribute-modal-close-button',
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL_SUBMIT_BUTTON:
    'ff-form-dynamic-attribute-modal-submit-button',
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL_CANCEL_BUTTON:
    'ff-form-dynamic-attribute-modal-cancel-button',
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL_CATEGORY:
    'ff-form-dynamic-attribute-modal-category',
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL_REQUEST_TYPE:
    'ff-form-dynamic-attribute-modal-request-type',
  FF_FORM_DYNAMIC_ATTRIBUTE_MODAL_ENDPOINT_KEY:
    'ff-form-dynamic-attribute-modal-endpoint-key',
  // Terms and Conditions Modal
  FF_TNC_CONDITIONS_MODAL: 'ff-tnc-conditions-modal',
  FF_TNC_CONDITIONS_MODAL_CANCEL_BUTTON:
    'ff-tnc-conditions-modal-cancel-button',
  FF_TNC_CONDITIONS_MODAL_ACCEPT_BUTTON:
    'ff-tnc-conditions-modal-accept-button',
  FF_TNC_EXTERNAL_LINK_MODAL: 'ff-tnc-external-link-modal',
  FF_TNC_EXTERNAL_LINK_CONTINUE_BUTTON: 'ff-tnc-external-link-continue-button',
  FF_TNC_EXTERNAL_LINK_CANCEL_BUTTON: 'ff-tnc-external-link-cancel-button',
  FF_QUILL_EXTERNAL_LINK_MODAL: 'ff-quill-external-link-modal',
  FF_QUILL_EXTERNAL_LINK_CONTINUE_BUTTON:
    'ff-quill-external-link-continue-button',
  FF_QUILL_EXTERNAL_LINK_CANCEL_BUTTON: 'ff-quill-external-link-cancel-button',
  // DA Label External Link
  FF_DA_LABEL_EXTERNAL_LINK_MODAL: 'ff-da-label-external-link-modal',
  FF_DA_LABEL_EXTERNAL_LINK_CONTINUE_BUTTON:
    'ff-da-label-external-link-continue-button',
  FF_DA_LABEL_EXTERNAL_LINK_CANCEL_BUTTON:
    'ff-da-label-external-link-cancel-button',
  // Credentials
  FF_CREDENTIALS_CREATE_FORM: 'ff-credentials-create-form',
} as const;

export default testIds;
